import moment from 'moment';
import axios from 'axios';
import * as React from 'react';
import Menu from '@mui/material/Menu';
import { Formik, Form } from 'formik';
import {
  IconButton,
  TextField,
  Typography,
  Button,
  Stack,
  Box,
  MenuItem,
  Autocomplete,
  CircularProgress,
} from '@mui/material';
import Iconify from '../Iconify';

const Filter = ({ toggleFilter, applyFilters }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div>
        <Box style={{ display: 'flex', justifyContent: 'end' }}>
          <IconButton onClick={handleClick}>
            <Iconify icon="ic:round-filter-list" />
            <Typography variant="h6"> Filter</Typography>
          </IconButton>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <Formik
              initialValues={{
                id: '',
                name: '',
                email: '',
                status: '',
                startDate: '',
                endDate: '',
              }}
              onSubmit={async (values) => {
                const updateValues = {
                  ...values,
                  startDate: values.startDate ? new Date(moment(values.startDate).startOf('day')) : null,
                  endDate: values.endDate ? new Date(moment(values.endDate).endOf('day')) : null,
                };
                applyFilters(updateValues);
              }}
            >
              {({ values, errors, touched, handleChange, setFieldValue, handleBlur, handleSubmit, isSubmitting }) => (
                <Form style={{ padding: '10px' }}>
                  <Stack direction="column" spacing={1} sx={{ width: '350px' }}>
                    <Stack direction="row" spacing={1}>
                      <TextField
                        id="name"
                        name="name"
                        label="Name"
                        value={values.name}
                        fullWidth
                        onChange={handleChange}
                      />
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <TextField
                        id="email"
                        name="email"
                        label="Email"
                        value={values.email}
                        fullWidth
                        onChange={handleChange}
                      />
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <TextField
                        select
                        fullWidth
                        id="status"
                        name="status"
                        label="Status"
                        value={values.status}
                        onChange={handleChange}
                      >
                        <MenuItem value="PENDING">PENDING</MenuItem>
                        <MenuItem value="REVIEWED">REVIEWED</MenuItem>
                      </TextField>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <TextField
                        id="startDate"
                        name="startDate"
                        label="Start Date"
                        type="date"
                        value={values.startDate}
                        onChange={handleChange}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <TextField
                        id="endDate"
                        name="endDate"
                        label="End Date"
                        type="date"
                        value={values.endDate}
                        onChange={handleChange}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Stack>

                    <Button variant="contained" type="submit" style={{ marginTop: '10px' }}>
                      Filter
                    </Button>
                  </Stack>
                </Form>
              )}
            </Formik>
          </Menu>
        </Box>
      </div>
    </>
  );
};

export default Filter;
